import { ErrorTypes } from '@/types/error';

export class InvalidResponseeError extends Error {
  constructor(message = '') {
    super(message);
    this.name = ErrorTypes.INVALID_RESPONSE;
    this.message = ErrorTypes.INVALID_RESPONSE;
  }
}
